// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    DispatchCompleteLoadProduct,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Data/Products/Handlers/LoadProductByPath";
import { DocumentModel, ProductModel } from "@insite/client-framework/Types/ApiModels";
import setCustomProductState from "@werner/App/Handlers/ProductDetails/SetCustomProductState";
import { VideoDocumentModel } from "@werner/App/Store/Reducers/xProductDetails";
import { getYoutubeThumbnail } from "@werner/XDL/Utilities/helpers";

export const XngPopulateApiParameter: any = (props: any) => {
    if (props.apiParameter?.getProductLines) {
        (props.apiParameter as any).expand = [...((props.apiParameter as any).expand || []), "productlines"];
    }
};

export function getVideosList(product: ProductModel) {
    return product.properties.videos?.split("||").filter(Boolean);
}

export function parseProductVideos(product: ProductModel): VideoDocumentModel[] {
    const documentVideos = getVideosList(product);

    const videos: VideoDocumentModel[] =
        documentVideos?.map((videoUrl: string) => {
            const youtubeVideo = !!videoUrl.match(
                /(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|playlist\?|watch\?v=|watch\?.+(?:&|&#38;);v=))([a-zA-Z0-9\-_]{11})?(?:(?:\?|&|&#38;)index=((?:\d){1,3}))?(?:(?:\?|&|&#38;)?list=([a-zA-Z\-_0-9]{34}))?(?:\S+)?/g,
            );
            const cloudinaryVideo = videoUrl.indexOf("cloudinary") !== -1;

            return {
                link: cloudinaryVideo ? videoUrl.replace("/video/upload/", "/video/upload/f_auto,q_auto/") : videoUrl,
                isYoutubeVideo: youtubeVideo,
                thumbnail: youtubeVideo
                    ? getYoutubeThumbnail(videoUrl)
                    : cloudinaryVideo
                    ? `${videoUrl.substring(0, videoUrl.lastIndexOf("."))}.jpg`
                    : "",
            };
        }) || [];

    return videos;
}

export function parseProductCustomState(product: ProductModel) {
    const videos = parseProductVideos(product);
    let selectedVideoIndex = -1;
    if (videos && videos.length > 0 && product?.images?.length === 0) {
        selectedVideoIndex = 0;
    }

    return {
        productId: product.id,
        videos,
        selectedVideoIndex,
    };
}

export const XngDispatchCompleteLoadProduct: typeof DispatchCompleteLoadProduct = props => {
    if (!props.apiResult) {
        return;
    }
    props.dispatch(setCustomProductState({ customProductStates: [parseProductCustomState(props.apiResult)] }));

    return DispatchCompleteLoadProduct(props);
};

addToChainAfter(chain, PopulateApiParameter, XngPopulateApiParameter);
replaceInChain(chain, DispatchCompleteLoadProduct, XngDispatchCompleteLoadProduct);
